import React from 'react';
import { Box, Typography, Stack, Divider, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Switch, TextField, Chip } from '@mui/material';
import HelpTooltip from '../../../../components/HelpTooltip';
import PresetFieldGroup from './PresetFieldGroup';

const PresetSection = ({
  title,
  helpText,
  fields,
  presetForm,
  handleChange,
  handleProfilesChange,
  getProfileDisplayName,
}) => (
  <Box>
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography variant="subtitle1" fontWeight="bold">
        {title}
      </Typography>
      <HelpTooltip title={helpText} />
    </Stack>
    <Divider sx={{ mb: 2 }} />
    {fields.map(field => (
      <Box key={field.name} sx={{ mb: field.type === 'group' ? 3 : 0, p: field.type === 'group' ? 2 : 0, bgcolor: field.type === 'group' ? '#f5f5f5' : 'transparent', borderRadius: field.type === 'group' ? 1 : 0 }}>
        {field.type === 'group' && (
          <Typography variant="subtitle2" sx={{ textTransform: 'capitalize', mb: 1 }}>
            {field.label}
          </Typography>
        )}
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 2, mt: field.type === 'group' ? 1 : 0 }}>
          {field.type === 'group' ? (
            field.subFields.map(subField => (
              <PresetFieldGroup
                key={subField.name}
                field={subField}
                presetForm={presetForm}
                handleChange={handleChange}
                handleProfilesChange={handleProfilesChange}
                getProfileDisplayName={getProfileDisplayName}
              />
            ))
          ) : (
            <PresetFieldGroup
              field={field}
              presetForm={presetForm}
              handleChange={handleChange}
              handleProfilesChange={handleProfilesChange}
              getProfileDisplayName={getProfileDisplayName}
            />
          )}
        </Box>
        {field.type === 'group' && <Divider sx={{ my: 2 }} />}
      </Box>
    ))}
  </Box>
);

export default PresetSection;